import { NgFor, NgIf } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { MatIconModule } from '@angular/material/icon';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogContent,
  MatDialogActions,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DialogData } from '../../models/dialog-data.model';
import { DialogItemModel } from '../../models/dialog-item.model';
import { OptionModel } from '../../models/optionModel';
import { TranslateModule } from '@ngx-translate/core';
import { MatListModule } from '@angular/material/list';
import { BreadcrumbItem } from '../../models/breadcrumb.interface';

@Component({
  selector: 'app-select-basic-department-popup',
  standalone: true,
  imports: [
    MatButtonModule,
    BreadcrumbComponent,
    NgFor,
    NgIf,
    MatIconModule,
    MatIconModule,
    TranslateModule,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatListModule,
  ],
  templateUrl: './select-basic-department-popup.component.html',
  styleUrl: './select-basic-department-popup.component.scss',
})
export class SelectBasicDepartmentPopupComponent {
  @Input() notAllowSelectedItems: string[] = [];
  allItems: DialogItemModel[] = [];
  selectedItem!: DialogItemModel;
  itemsInBox: DialogItemModel[] = [];
  breadcrumbItems: BreadcrumbItem[] = [];
  isRoot = false;

  constructor(
    public dialogRef: MatDialogRef<SelectBasicDepartmentPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  ngOnInit() {
    this.isRoot =
      this.data.selectNode.id === '00000000-0000-0000-0000-000000000000' || this.data.selectNode.id === 0
        ? true
        : false;
    if (this.data.isGuidId) {
      this.selectedItem =
        this.data.selectNode.id === '00000000-0000-0000-0000-000000000000'
          ? new DialogItemModel('root', '00000000-0000-0000-0000-000000000000', '00000000-0000-0000-0000-000000000000')
          : this.data.items.find((item) => item.id === this.data.selectNode.id);
    } else {
      this.selectedItem =
        this.data.selectNode.id === 0
          ? new DialogItemModel('root', 0, 0)
          : this.data.items.find((item) => item.id === this.data.selectNode.id);
    }

    this.initDataForDialog();
    this.dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === 'Escape') {
        this.onCancelClick();
      }
      if (event.key === 'Enter') {
        this.dialogRef.close(this.selectedItem);
      }
    });
  }

  initDataForDialog() {
    this.itemsInBox = this.data.items.filter((item) => item.parentId === this.selectedItem.id);
    if (this.selectedItem.id === '00000000-0000-0000-0000-000000000000' || this.selectedItem.id === 0) {
      this.breadcrumbItems = [];
    } else {
      const root: BreadcrumbItem = {
        id: '00000000-0000-0000-0000-000000000000',
        parentId: 0,
        name: 'Root',
      };

      this.breadcrumbItems = [
        root,
        ...this.findParentItems(this.selectedItem, this.data.items, this.data.items.length),
        this.selectedItem,
      ];
    }
  }

  findParentItems(node: DialogItemModel, locations: DialogItemModel[], parentLevel: number) {
    const result: DialogItemModel[] = [];
    let tempNode = node;
    for (let i = 0; i < parentLevel; i++) {
      const parent = locations.find((item) => item.id === tempNode.parentId);
      if (parent) {
        result.unshift(parent);
        tempNode = parent;
      } else {
        break;
      }
    }
    return result;
  }

  onItemClicked(item: OptionModel) {
    if (this.data.isGuidId) {
      this.selectedItem =
        item.id === '00000000-0000-0000-0000-000000000000'
          ? new DialogItemModel('root', '00000000-0000-0000-0000-000000000000', '00000000-0000-0000-0000-000000000000')
          : this.data.items.find((location) => location.id === item.id);
    } else {
      this.selectedItem =
        item.id === '00000000-0000-0000-0000-000000000000'
          ? new DialogItemModel('root', 0, 0)
          : this.data.items.find((location) => location.id === item.id);
    }
    if (this.selectedItem.id !== '00000000-0000-0000-0000-000000000000' || this.selectedItem.id != 0) {
      this.isRoot = false;
    } else {
      this.isRoot = true;
    }
    this.initDataForDialog();
  }

  onChildClicked(item: DialogItemModel) {
    if (item.id !== '00000000-0000-0000-0000-000000000000' || this.selectedItem.id != 0) {
      this.isRoot = false;
    } else {
      this.isRoot = true;
    }
    this.selectedItem = item;
    this.initDataForDialog();
  }

  haveChild(id: string) {
    return !!this.data.items.find((item) => item.parentId == id);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  canSelected(id: string) {
    return !this.notAllowSelectedItems.some((item) => item == id);
  }

  onSubmit() {
    this.dialogRef.close(this.selectedItem);
  }
}
